import { AubadeComponent } from "js/front/bootstrap";
import { Sprite } from '../../tools/Sprite';
import { gsap } from 'gsap';
import { faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { customization } from 'storage';

class ChooseProducts extends AubadeComponent{
	constructor(e, b){
		super(e, b);
		this.sprites 	= new Map();

		this.inputs 	= Array.from(this.element.querySelectorAll("form input"));
		this.choices 	= this.element.querySelectorAll(":scope > .left li");
		this.imgSprites = this.element.querySelectorAll(".sprite-content img");
		this.imgSprites.forEach(element => {
			 this.sprites.set(element.dataset.category, new Sprite(element));
		});

		this.title 		= this.element.querySelector("h1");
		this.right 		= this.element.querySelector(":scope > .right");
		this.mask 		= this.element.querySelector(":scope > .right .mask");
		this.innerBg 	= this.element.querySelector(":scope > .right .inner .bg");
		this.img 		= this.element.querySelector(":scope > .right img");

		this.header =  this.bootstrap.components.get(document.querySelector("header"));
		this.continue = this.element.querySelector(".left .button-wrapper button");
		this.link = this.continue.querySelector("a");

		this.bathtuborshower = this.element.dataset.bathtuborshower == "1";

		customization.setScene(this.element.dataset.scene).then(() => customization.save());
	};

	onInputClick = async (e) => {
		let el = e.currentTarget;

		this.setContinue();
		this.updateCustomization();

		this.playSprite(el);

		if(this.bathtuborshower){
			if(el.value == "baignoire" && el.checked){
				this.inputs.filter(input => input.value == 'douche').forEach(input => {
					input.checked = !el.checked
					this.playSprite(input);
				});
			}
			else if(el.value == "douche" && el.checked){
				this.inputs.filter(input => input.value == 'baignoire').forEach(input => {
					input.checked = !el.checked
					this.playSprite(input);
				});
			}
		}
	}

	async playSprite(element){
		let sprite = this.sprites.get(element.value);
		if(!sprite) return;
		await sprite.load();

		element.checked ? sprite.play() : sprite.reverse();
	}

	updateCustomization(){
		customization.setEquipment(this.inputs.filter(item => item.checked).map(item => item.value));
		customization.save();
	}

	onContinueClick = (e) =>{
		if(this.continue.classList.contains("disabled")) {
			e.preventDefault();
			e.stopPropagation();
			return;
		}
		dataLayer.push({'event': 'Validation Choix Équipement', 'TypeEquipment':[...customization.equipment.values()].join(',')});
	}

	setContinue(){
		let disabled = true;
		this.inputs.forEach(element => {
			if(element.checked) disabled = false;
		});
		this.continue.classList.toggle("disabled", disabled);
	}

	attach(){
		this.inputs.forEach(element=> element.addEventListener("change", this.onInputClick));
		this.link.addEventListener("click", this.preventAndStop);
		this.continue.addEventListener("click", this.onContinueClick, {capture:true});
	}
	detach(){
		this.inputs.forEach(element=> element.removeEventListener("change", this.onInputClick));
		this.link.removeEventListener("click", this.preventAndStop);
		this.continue.removeEventListener("click", this.onContinueClick, {capture:true});
	}

	preventAndStop = (e) => {
		e.preventDefault();
		e.stopPropagation();
	}

	open(){
		this.header.openHeaderNotHome();
		const t = gsap.timeline({delay : this.router.previous ? 0 : 0.56});
		if(this.viewport.medias.desktop){
			const delta = this.viewport.width/2;		
			t.to(this.mask,{x: -delta, ease: "expo.out", duration:0.8},0);
			t.fromTo(this.img,{x: delta/3},{x:0, ease: "expo.out", duration:0.8},0);
			t.fromTo(this.innerBg,{x: delta/3},{x:0, ease: "expo.out", duration:1},0.15);
			t.fromTo(this.innerBg,{alpha: 0},{alpha:1, duration:0.5},0.15);
			t.add(()=> this.mask.remove());
		}
		else{
			this.mask.remove();
		}
		t.fromTo(this.title,{y:60},{y:0, ease:'power3.out', duration:0.8},0);
		t.fromTo(this.title,{alpha:0},{alpha:1, duration:0.4},0);		
		t.fromTo(this.choices,{y:30},{y:0, ease:'power3.out', duration:0.8, stagger:0.06},0.15);
		t.from(this.choices,{alpha:0, duration:0.4, stagger:0.06 },0.15);

		t.fromTo(this.continue,{y:30},{y:0, ease:'power3.out', duration:0.8, stagger:0.08, clearProps:'all'},0.4);
		t.from(this.continue,{autoAlpha:0, duration:0.4, stagger:0.08, clearProps:'all' },0.4);
		
		return t;
	}
	close(){		
		var t = gsap.timeline();
		t.to(this.element,{alpha:0, duration: 0.3},0);
		return t;
	}


}

export { ChooseProducts };